<template>
  <div class="form-group">
    <label>{{ props.label }}</label>
    <DxSelectBox v-model="inputValue" :dataSource="props.dataSource" v-bind="{ ...getSelectBoxDefaultProperties() }">
      <DxValidator ref="dxValidatorRef">
        <DxCustomRule :validationCallback="validateInput" :message="$t('shared.input_box.campo_requerido')" />
      </DxValidator>
    </DxSelectBox>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref } from 'vue';
import { modalDefinedEmits, type ToolbarReference, useModalBuilder } from '@helpers/modal-building-helper';
import { messageBoxResult } from '@components/dialogs/message-box';
import { DxButton } from 'devextreme-vue/button';
import { DxValidator, DxCustomRule } from 'devextreme-vue/validator';
import { DxSelectBox } from 'devextreme-vue';
import { getSelectBoxDefaultProperties } from '@helpers/grid-helper';

const props = withDefaults(defineProps<{
  label: string,
  required: boolean,
  dataSource: any,
  valorInicial?: string | null,
}>(), {
  label: '',
  required: false,
  dataSource: [],
  valorInicial: null,
});

defineEmits([...modalDefinedEmits]);

const inputValue = ref<string | null>(props.valorInicial ?? null);
const dxValidatorRef = ref<DxValidator>();

onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);

  configureButtons(modal);
});

export interface InputSelectBoxModalResult {
  result: string;
  value: string | null;
}

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton: ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;

  ({ okButton, cancelButton } = modal.standardButtons.addOkCancel());
  okButton.update(w => w.onClick = () => {
    const validationResult = dxValidatorRef.value!.instance!.validate();
    if (validationResult.isValid)
      modal.close({ result: messageBoxResult.ok, value: inputValue.value });
    else
      dxValidatorRef.value!.instance!.focus();
  });
  cancelButton.update(w => w.onClick = () => modal.close({ result: messageBoxResult.cancel }));
}

function validateInput(e: { value: string | null }): boolean {
  if (!props.required)
    return true;

  return e.value !== null && e.value.trim() !== "";
}
</script>

<style scoped lang="scss">
.form-group>label {
  margin-bottom: 1rem;
}

.form-group {
  min-height: 110px;
}
</style>